import { Slide, Zoom } from "react-awesome-reveal";
import { Link } from "react-router-dom";

const SliderCard = ({ title, image }) => {
  return (
    <div className="m-1">
      <div className="partner-list">
        <img
          src={image}
       style={{
        width: "100px",
        height: "100px",
        objectFit: "cover",
        borderRadius: "30%",
        marginRight: "15px"
        }}
          className="img-fluid"
          alt="product"
        />
        <h6 class="card-title partner">
          <div>{title}</div>
        </h6>
      </div>
    </div>
  );
};

export default SliderCard;
